import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { ReactComponent as IconeChatbot } from "../../../../assets/icons/chatbot.svg";
import * as S from "./styles";

const URL_IA = "https://ai.embed.it";

// A IA abre em nova guia; o destino do chatbot ainda não existe, então ele só avisa que não está integrado.
export default function BotaoAssistente({ tipo, compacto = false }) {
  const { t: tAssistenteIA } = useTranslation("assistenteIA");
  const ehIA = tipo === "ia";

  const aoClicar = () => {
    if (ehIA) {
      window.open(URL_IA, "_blank", "noopener,noreferrer");
      return;
    }

    toast.info(tAssistenteIA("messages.chatbotNotIntegrated"));
  };

  return (
    <S.Botao
      type="button"
      $compacto={compacto}
      aria-label={tAssistenteIA(ehIA ? "buttons.openIa" : "buttons.openChatbot")}
      onClick={aoClicar}
    >
      {ehIA ? (
        <>
          <S.Brilhos aria-hidden="true" />
          <S.TextoIA aria-hidden="true">{tAssistenteIA("labels.ia")}</S.TextoIA>
        </>
      ) : (
        <IconeChatbot aria-hidden="true" />
      )}
    </S.Botao>
  );
}
